import React from 'react';
import { formatValue, formatConfidence } from '../../utils/formatters';

const EvaluationSection = ({ 
    evaluation, 
    gatekeeperRejected, 
    gatekeeperShouldContinue,
    parsedScore, 
    scoreVisuals,
    customerFitData,
    customerFitVisuals,
    headerActions
}) => {
    if (!evaluation || gatekeeperRejected) {
        return null;
    }

    const { hasCustomerFitRating, hasCustomerFitConfidence, customerFitRating, customerFitConfidence } = customerFitData;

    return (
        <div style={{ marginBottom: '30px' }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '10px', marginBottom: '15px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <h4 style={{ color: '#e0e0e0', fontWeight: '600', margin: 0 }}>Evaluation</h4>
                    {gatekeeperShouldContinue === true && (
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                padding: '4px 10px',
                                borderRadius: '999px',
                                fontSize: '11px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                fontWeight: 600,
                                color: '#34d399',
                                backgroundColor: 'rgba(52, 211, 153, 0.15)',
                                border: '1px solid rgba(52, 211, 153, 0.4)'
                            }}
                        >
                            Gatekeeper Passed
                        </span>
                    )}
                </div>
                {headerActions && (
                    <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
                        {headerActions}
                    </div>
                )}
            </div>
            <div style={{ 
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '6px',
                padding: '15px'
            }}>
                <div
                    style={{
                        marginBottom: '16px',
                        display: 'grid',
                        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                        gap: '14px'
                    }}
                >
                    <div
                        style={{
                            background: scoreVisuals.gradient,
                            border: `1px solid ${scoreVisuals.border}`,
                            borderRadius: '16px',
                            padding: '16px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: '8px',
                            boxShadow: `0 12px 28px ${scoreVisuals.shadow}`
                        }}
                    >
                        <span
                            style={{
                                color: '#9ca3af',
                                fontSize: '12px',
                                letterSpacing: '0.08em',
                                textTransform: 'uppercase',
                                fontWeight: 600
                            }}
                        >
                            Score
                        </span>
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'baseline',
                                gap: '6px'
                            }}
                        >
                            <span
                                style={{
                                    fontSize: '28px',
                                    fontWeight: 700,
                                    color: '#f9fafb'
                                }}
                            >
                                {parsedScore !== null
                                    ? (Number.isInteger(parsedScore) ? parsedScore : parsedScore.toFixed(1))
                                    : '—'}
                            </span>
                            {parsedScore !== null && (
                                <span
                                    style={{
                                        fontSize: '14px',
                                        color: '#9ca3af',
                                        fontWeight: 500
                                    }}
                                >
                                    /10
                                </span>
                            )}
                        </div>
                        <span
                            style={{
                                color: scoreVisuals.accent,
                                fontSize: '13px',
                                fontWeight: 600
                            }}
                        >
                            {scoreVisuals.label}
                        </span>
                    </div>

                    {(hasCustomerFitRating || hasCustomerFitConfidence) && (
                        <div
                            style={{
                                background: customerFitVisuals.gradient,
                                border: `1px solid ${customerFitVisuals.border}`,
                                borderRadius: '16px',
                                padding: '16px',
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '8px',
                                boxShadow: `0 12px 28px ${customerFitVisuals.shadow}`
                            }}
                        >
                            <span
                                style={{
                                    color: '#9ca3af',
                                    fontSize: '12px',
                                    letterSpacing: '0.08em',
                                    textTransform: 'uppercase',
                                    fontWeight: 600
                                }}
                            >
                                Customer Fit
                            </span>
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'baseline',
                                    gap: '8px'
                                }}
                            >
                                <span
                                    style={{
                                        fontSize: '24px',
                                        fontWeight: 700,
                                        color: '#f9fafb'
                                    }}
                                >
                                    {hasCustomerFitRating ? formatValue(customerFitRating) : '—'}
                                </span>
                                {hasCustomerFitConfidence && (
                                    <span
                                        style={{
                                            fontSize: '13px',
                                            fontWeight: 500,
                                            color: '#9ca3af',
                                            backgroundColor: 'rgba(15, 23, 42, 0.45)',
                                            padding: '4px 10px',
                                            borderRadius: '999px'
                                        }}
                                    >
                                        Confidence {formatConfidence(customerFitConfidence)}
                                    </span>
                                )}
                            </div>
                            <span
                                style={{
                                    color: customerFitVisuals.accent,
                                    fontSize: '13px',
                                    fontWeight: 600
                                }}
                            >
                                {customerFitVisuals.label}
                            </span>
                        </div>
                    )}
                </div>
                {evaluation.prose && (
                    <p style={{ 
                        margin: '10px 0 0 0',
                        color: '#d0d0d0',
                        lineHeight: '1.6'
                    }}>
                        {evaluation.prose}
                    </p>
                )}
            </div>
        </div>
    );
};

export default EvaluationSection;


